// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LP20d","controls":"styles_controls__3b8M2","charLimit":"styles_charLimit__JbQw6","input":"styles_input__NMuZ-","send":"styles_send__2V997"};